import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/services/modal.service';
import { ToastService } from 'src/app/services/toasts.service';
import { PDFExportModalComponent } from '../pdf-export-modal/pdf-export-modal.component';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { ExcelExportModalComponent } from '../excel-export-modal/excel-export-modal.component';

@Component({
    selector: 'app-export-planogram-modal',
    templateUrl: './export-planogram-modal.component.html',
    styleUrls: ['./export-planogram-modal.component.scss']
})
export class ExportPlanogramModalComponent implements OnInit {

  nexgenPogCode : number | undefined;

  constructor(
    private modalService: ModalService,
    public activeModal: NgbActiveModal,
    private toastService: ToastService,
    private planogramApiService: PlanogramApiService
  ) { }

  ngOnInit(): void {
  }

  confirm(exportType: number): void {
    if(exportType == 0){
      this.activeModal.close(null);
      this.modalService.openModalWithOptions(PDFExportModalComponent, {
        centered : true,
        size: 'xl'
      });
      return;
    }
    else if(exportType == 1){
      this.activeModal.close(null);
      this.modalService.openModalWithOptions(ExcelExportModalComponent, {
        centered : true,
        size: 'xl'
      });
      return;
    }
    else if(exportType == 2){
      let exportDescription: string = 'Images';
      let message: string = `Exporting planogram ${exportDescription}`;
      let additionalData: any = {};
      this.toastService.show(message, { classname: `bg-dark text-light p-3 fs-5`, delay: 5000 })
      this.planogramApiService.exportPlanogram(exportType, exportDescription, additionalData);
      this.activeModal.close(null);
    }
  }

  cancel(): void {
    this.activeModal.close(null);
  }
}
